import * as React from 'react';

export const Form: React.FC<React.FormHTMLAttributes<HTMLFormElement>> = (attrs) => {
	return <form className="form" {...attrs}>{attrs.children}</form>;
};
